export default ({ i18n }) => ({
  CURRENTLY_ASSIGNED: i18n.t`AssignmentsSummary - Currently assigned`,
  OVERDUE: i18n.t`AssignmentsSummary - Overdue`,
  TOTAL_ASSIGNMENTS: i18n.t`AssignmentsSummary - Total assignments`
});
  